<template>
  <v-btn
    :color="color"
    block
    :loading="isLoading || $store.getters.isLoading"
    :disabled="!valid"
    rounded
    large
    @click="$emit('click', false)"
  >
    <span class="btn letters" v-text="$t(title)" />
  </v-btn>
</template>

<script>
export default {
  name: "ButtonSuccess",
  props: {
    title: {
      type: String,
      default: "general.confirm",
    },
    color: {
      type: String,
      default: "#4CAF50",
    },
    valid: {
      type: Boolean,
      default: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.letters {
  color: #fff;
}
</style>
